export default __webpack_public_path__ + "static/background_mask-f2431677cbd63b0633b184779cd08172.png";